import { useEffect } from 'react';

/**
 * Closes on a click outside the element.
 *
 * Bound on `pointerdown` rather than `click`: a click that starts inside a
 * popover and ends outside it — selecting text, dragging a slider — would
 * otherwise close the thing being used.
 */
export function useOutsideClick(
  active: boolean,
  ref: { current: HTMLElement | null },
  onOutside: () => void,
): void {
  useEffect(() => {
    if (!active) return;

    const onPointerDown = (event: PointerEvent): void => {
      const target = event.target;
      if (target instanceof Node && ref.current && !ref.current.contains(target)) onOutside();
    };

    document.addEventListener('pointerdown', onPointerDown);
    return () => document.removeEventListener('pointerdown', onPointerDown);
  }, [active, ref, onOutside]);
}
